import { render } from "./AppSegment.vue?vue&type=template&id=23e48fb8"
import script from "./AppSegment.vue?vue&type=script&lang=js"
export * from "./AppSegment.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__